// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1u-Rq","theme_selector_container":"style_theme_selector_container__33ABu","main":"style_main__2ITrv","back_button":"style_back_button__3oxCo"};